import { Node, type NodeProps } from '@xyflow/react';
import { useIntl } from 'react-intl';
import { IconServerBolt, IconWebhook } from '@rossum/ui/icons/tabler';
import { SvgIcon, useTheme } from '@rossum/ui/material';
import { BaseNode } from './BaseNode';
import { HOOK_NODE_HEIGHT, type HookNodeData } from './computeLayout';

export const HookNode = ({ id, data }: NodeProps<Node<HookNodeData>>) => {
  const theme = useTheme();
  const intl = useIntl();

  const HookIcon = data.hookType === 'function' ? IconServerBolt : IconWebhook;

  const tooltipTitle = data.active
    ? data.label
    : intl.formatMessage(
        {
          id: 'containers.settings.queues.queue.overview.inactiveHookTooltip',
        },
        { label: data.label }
      );

  return (
    <BaseNode
      id={id}
      label={data.label}
      accentColor={theme.palette.warning.main}
      accentLightColor={theme.palette.warning.light}
      icon={
        <SvgIcon fontSize="small" sx={{ color: theme.palette.text.secondary }}>
          <HookIcon />
        </SvgIcon>
      }
      dashed={!data.active}
      baseOpacity={data.active ? 1 : 0.6}
      minHeight={HOOK_NODE_HEIGHT}
      tooltipTitle={tooltipTitle}
      tooltipEnterDelay={data.active ? 500 : 0}
      detailSections={[
        {
          label: intl.formatMessage({
            id: 'containers.settings.queues.queue.overview.node.dependencies',
          }),
          items: data.dependencies,
        },
        {
          label: intl.formatMessage({
            id: 'containers.settings.queues.queue.overview.node.targets',
          }),
          items: data.targets,
        },
      ]}
    />
  );
};
